import React, {Component} from 'react';
import {Map} from "immutable";
import {Map as MapLeftlet, Marker, Popup, TileLayer, Tooltip} from 'react-leaflet';
import {Icon, Layout, Menu, Tag} from 'antd';
import {
    parseUsername,
    iconGsm, iconPark, iconRun, iconStop
} from './util';
import GoogleMapsLoader from 'google-maps';
import * as colors from 'material-ui/styles/colors';
import {divIcon} from 'leaflet';

//Config locate
import moment from 'moment';
import 'moment/locale/vi';

moment.locale('vi');

const {Sider, Content, Footer} = Layout;
const position = [10.766685, 106.684709];
const keyApi = 'AIzaSyAxZVwP4oiId0OxqGlwA1y6VNN4DWTh4Gk';
const URL = "https://api.dinhviso.com.vn/";
let google;

GoogleMapsLoader.load(function (goo) {
    google = goo;
});

export default class EventMaps extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bounds: [[20.9591091, 105.3436084], [10.7827413, 106.5560123]],
            viewIssues: [],
            polyline: [[position]],
            viewMarker: Map,
            viewTech: Map({}),
            isShowLeftPanel: true,
            isShowIssueDetail: false,
            openKeys: [],
            issue: {id: 0},
            techLocation: Map({}),
            firstBound: true,
            overviewByIssues: Map({}),
        };

        this.selectedIssue = this.selectedIssue.bind(this);
    }

    componentWillMount() {
        let viewMarker = Map({});

        this.setState({
            viewMarker,
        });
    }

    componentDidMount() {
        if (this.props.issues) {
            this.getOverviewIssues(this.props.issues);

            if (this.state.viewMarker.size === 0 || this.state.openKeys.length === 0) {
                let viewMarker = Map({});
                let bounds = [];
                let nowDate = moment().format('DD-MM-YYYY');

                this.props.issues.map((issue) => {
                    let startDate = moment(issue.startDate).format('DD-MM-YYYY');

                    if (startDate === nowDate) {
                        viewMarker = viewMarker.set(issue.id.toString(), issue);
                    }

                    if (issue.latitude && issue.longitude) {
                        if (startDate === nowDate) {
                            bounds.push([issue.latitude, issue.longitude]);
                        }
                    }
                });

                if (bounds.length > 0) {
                    this.setState({viewMarker, bounds});
                } else {
                    this.setState({viewMarker});
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.issues != nextProps.issues && nextProps.issues.length > 0) {
            this.getOverviewIssues(nextProps.issues);

            nextProps.issues.sort(function (issue, nextIssue) {
                if (issue.start && nextIssue.start) {
                    return moment(issue.start).unix() - moment(nextIssue.start).unix();
                }

                return -1;
            });
        }

        if (this.props.techLocation.size === 0 && nextProps.techLocation.size > 0) {
            let bounds = [];
            let viewTech = Map({});

            nextProps.techLocation.map((location) => {
                let roadmaps = location.roadmaps;

                if (roadmaps && roadmaps.length > 0) {
                    let latitude = roadmaps[roadmaps.length - 1].latitude;
                    let longitude = roadmaps[roadmaps.length - 1].longitude;

                    if (latitude && longitude) {
                        bounds.push([latitude, longitude]);
                    }
                }

                viewTech = viewTech.set(location.id, location);
            });

            if (bounds.length > 0) {
                this.setState({bounds, viewTech});
            }
        }

        if (this.props.dateControl !== nextProps.dateControl) {
            this.setState({
                openKeys: [],
                issue: {id: 0},
            });
        }
    }

    getOverviewIssues(issues) {
        let overviewByIssues = Map({});

        issues.map((issue) => {
            let cIssue = this.state.viewMarker.get(issue.id.toString());

            if (cIssue && cIssue.kmDistance && cIssue.duration) {
                issue.kmDistance = cIssue.kmDistance;
                issue.duration = cIssue.duration;
            }

            if (issue.assignedToID && issue.assignedToID > 0) {
                let overviewByIssue = overviewByIssues.get(issue.assignedToID.toString());

                if (overviewByIssue) {
                    if (issue.statusID === 7) {
                        overviewByIssue.maintenance++;
                    }

                    if (issue.statusID === 3) {
                        overviewByIssue.done++;
                    }

                    if (issue.statusID === 5) {
                        overviewByIssue.cancel++;
                    }

                    overviewByIssues = overviewByIssues.set(issue.assignedToID.toString(), overviewByIssue);
                } else {
                    overviewByIssue = {
                        maintenance: 0,
                        done: 0,
                        cancel: 0
                    };

                    if (issue.statusID === 7) {
                        overviewByIssue.maintenance++;
                    }

                    if (issue.statusID === 3) {
                        overviewByIssue.done++;
                    }

                    if (issue.statusID === 5) {
                        overviewByIssue.cancel++;
                    }

                    overviewByIssues = overviewByIssues.set(issue.assignedToID.toString(), overviewByIssue);
                }
            }

            if (issue.assignedMore && issue.assignedMore.length > 0) {
                let arrAssignedMore = issue.assignedMore.split(',');

                if (arrAssignedMore && arrAssignedMore.length > 0) {
                    arrAssignedMore.map((assignedID) => {
                        let overviewByIssue = overviewByIssues.get(assignedID);

                        if (overviewByIssue) {
                            if (issue.statusID === 7) {
                                overviewByIssue.maintenance++;
                            }

                            if (issue.statusID === 3) {
                                overviewByIssue.done++;
                            }

                            if (issue.statusID === 5) {
                                overviewByIssue.cancel++;
                            }

                            overviewByIssues = overviewByIssues.set(assignedID, overviewByIssue);
                        } else {
                            overviewByIssue = {
                                maintenance: 0,
                                done: 0,
                                cancel: 0
                            };

                            if (issue.statusID === 7) {
                                overviewByIssue.maintenance++;
                            }

                            if (issue.statusID === 3) {
                                overviewByIssue.done++;
                            }

                            if (issue.statusID === 5) {
                                overviewByIssue.cancel++;
                            }

                            overviewByIssues = overviewByIssues.set(assignedID, overviewByIssue);
                        }
                    });
                }
            }
        });

        this.setState({overviewByIssues});
    }

    removeAllPolyline() {
        const users = this.props.usersMap.filter(user => user.get('firstname')).toArray();
        users.map((userMap) => {
            const user = userMap.toObject();
            let polyline = this.state[`polytech${user.id.toString()}`];

            if (polyline && polyline.length > 0) {
                this.setState({[`polytech${user.id.toString()}`]: []});
            }
        });
    }

    selectedIssue(item) {
        const arrItemKey = item.key.split('#');
        if (!arrItemKey || arrItemKey.length < 2) {
            return;
        }

        let type = arrItemKey[0];
        let id = arrItemKey[1];

        switch (type) {
            case 'issue':
                let issue = this.props.issuesMap.get(id);

                if (issue) {
                    issue = issue.toJS();
                    this.props.handleOpenModal(issue);
                }

                break;
            default:
                let viewIssues = [];
                let bounds = [];
                let viewMarker = Map({});
                let viewTech = Map({});
                let deviceID = arrItemKey.length === 3 ? arrItemKey[2] : '';

                if (deviceID.length > 0) {
                    let techLocation = this.props.techLocation.get(deviceID);
                    if (techLocation) {
                        viewTech = viewTech.set(deviceID, techLocation);

                        let roadmaps = techLocation.roadmaps;
                        if (roadmaps && roadmaps.length > 0) {
                            let roadmap = roadmaps[roadmaps.length - 1];

                            bounds.push([roadmap.latitude, roadmap.longitude]);
                        }
                    }
                }

                this.props.issues.map((issue) => {
                    if (issue.assignedToID && issue.assignedToID === parseInt(id)) {
                        viewMarker = viewMarker.set(issue.id.toString(), issue);
                        viewIssues.push(issue);
                        if (issue.latitude && issue.longitude) {
                            bounds.push([issue.latitude, issue.longitude]);
                        }
                    }
                });

                this.setState({
                    viewIssues,
                    bounds,
                    viewMarker,
                    viewTech,
                });
        }
    }

    countIssuesByuser(userID) {
        let arrIssue = this.props.issues.filter((issue) => {
            if (issue.assignedToID && issue.assignedToID === parseInt(userID)) {
                return true;
            }

            if (issue.assignedMore && issue.assignedMore.length > 0) {
                let arrAssignedMore = issue.assignedMore.split(',');

                if (arrAssignedMore && arrAssignedMore.length > 0) {
                    for (let index = 0; index < arrAssignedMore.length; index++) {
                        let assignedID = parseInt(arrAssignedMore[index]);

                        if (assignedID === parseInt(userID)) {
                            return true;
                        }
                    }
                }
            }
        });

        return arrIssue.length;
    }

    parsePanelHeader(issue) {
        let saleName = '';
        let startTime = '';

        let sale = this.props.usersMap.get(issue.saleID ? issue.saleID.toString() : 0);
        if (sale) {
            saleName = `- ${parseUsername(sale.get('firstname'), sale.get('lastname'))}`;
        }

        let arrStartTime = issue.startTime.split(':');
        if (arrStartTime && arrStartTime.length >= 2) {
            startTime = `${arrStartTime[0]}:${arrStartTime[1]}`;
        }

        return `${startTime} - ${issue.username} ${saleName}`;
    }

    getHeaderName(userID) {
        if (userID) {
            let user = this.props.usersMap.get(userID.toString());

            if (user) {
                return parseUsername(user.get('firstname'), user.get('lastname'));
            }
        }

        return <Icon type="user"/>;
    }

    getDistance(issuesID) {
        let viewingIssue = this.state.viewMarker.get(issuesID);
        if (viewingIssue && viewingIssue.kmDistance) {
            return viewingIssue.kmDistance;
        }

        return 0;
    }

    getDuration(issuesID) {
        let viewingIssue = this.state.viewMarker.get(issuesID);
        if (viewingIssue && viewingIssue.duration) {
            return viewingIssue.duration;
        }

        return '';
    }

    getColorByAssignedID(assignedToID) {
        if (assignedToID && assignedToID > 0) {
            let user = this.props.usersMap.get(assignedToID.toString());

            if (user && user.get('color')) {
                return user.get('color');
            }
        }

        return colors.grey500;
    }

    getTooltipInfo(issue) {
        if (issue.startTime) {
            let arrStartTime = issue.startTime.split(':');

            if (arrStartTime.length >= 2) {
                return `${arrStartTime[0]}:${arrStartTime[1]} - ${issue.username}`
            }

            return `${issue.startTime} - ${issue.username}`
        }

        return `${issue.username}`
    }

    getIconByStatus(statusID) {
        switch (statusID) {
            case 3:
                return 'done';
            case 2:
                return 'play_arrow';
            case 4:
                return 'perm_phone_msg';
            case 6:
                return 'error_outline';
            case 5:
                return 'clear';
            case 7:
                return 'build';
            case 8:
                return 'loop';
            default:
                return '';
        }
    }

    getStatuscolor(location) {
        switch (location.status) {
            case 1:
                return '#DE6909';
            case 2:
                return '#892fbd';
            case 3:
                return '#1b91f5';
            case 6:
                return '#000000';
            case 4:
                return '#be0000';
            case 5:
                return '#ffd700';
            default:
                return '#9E9E9E';
        }
    }

    getAncestorKeys = (key) => {
        const map = {
            sub3: ['sub2'],
        };
        return map[key] || [];
    };

    getTechName(deviceID) {
        const users = this.props.usersMap.filter(user => user.get('deviceID') === deviceID).toArray();

        if (users && users.length > 0) {
            return parseUsername(users[0].get('firstname'), users[0].get('lastname'));
        }

        return '';
    }

    getStatusIcon(status) {
        switch (status) {
            case 1:
                return iconStop;
            case 2:
                return iconPark;
            case 3:
                return iconRun;
        }

        return iconGsm;
    }

    getStatusName(status) {
        switch (status) {
            case 1:
                return 'Đỗ';
            case 2:
                return 'Dừng';
            case 3:
                return 'Đang chạy';
            case 5:
                return 'Mất GPS';
        }

        return 'Mất GSM';
    }

    render() {
        const users = this.props.usersMap.filter(user => user.get('firstname')).toArray();

        return (
            <Layout style={{
                height: '100%',
                width: '100%',
                position: 'fixed',
            }}>
                <Sider
                    className="maps-left-menu"
                    breakpoint="lg"
                    collapsedWidth="0"
                    width={450}
                    style={{
                        background: '#fff',
                        zIndex: 1500,
                    }}
                >
                    <div>
                        <h3
                            style={{
                                position: 'relative',
                                top: '15px',
                                width: '100%',
                                zIndex: 100,
                                textAlign: 'left',
                                paddingLeft: '10px',
                                paddingBottom: '10px',
                                backgroundColor: '#fff',
                                borderBottom: '1px solid #e9e9e9'
                            }}
                        >
                            Ngày : {this.props.dateControl}
                        </h3>
                        <Menu
                            className={'left-panel-user'}
                            mode="inline"
                            style={{
                                position: 'fixed',
                                overflow: 'auto',
                                height: '100%',
                                width: '450px',
                                paddingBottom: '90px',
                                paddingTop: '15px'
                            }}
                            selectedKeys={[]}
                            onSelect={this.selectedIssue}
                            onOpenChange={(openKeys) => {
                                const state = this.state;
                                const latestOpenKey = openKeys.find(key => !(state.openKeys.indexOf(key) > -1));
                                const latestCloseKey = state.openKeys.find(key => !(openKeys.indexOf(key) > -1));

                                let nextOpenKeys = [];
                                if (latestOpenKey) {
                                    nextOpenKeys = this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
                                }

                                if (latestCloseKey) {
                                    nextOpenKeys = this.getAncestorKeys(latestCloseKey);
                                }

                                if (nextOpenKeys && nextOpenKeys.length > 0) {
                                    this.selectedIssue({key: nextOpenKeys[0]});
                                }

                                if (openKeys.length === 0) {
                                    let viewMarker = Map({});
                                    let viewTech = Map({});
                                    let viewIssues = [];
                                    let bounds = [];

                                    this.props.issues.map((issue) => {
                                        viewMarker = viewMarker.set(issue.id.toString(), issue);
                                        viewIssues.push(issue);
                                        if (issue.latitude && issue.longitude) {
                                            bounds.push([issue.latitude, issue.longitude]);
                                        }
                                    });

                                    this.props.techLocation.map((location) => {
                                        let roadmaps = location.roadmaps;

                                        if (roadmaps && roadmaps.length > 0) {
                                            let latitude = roadmaps[roadmaps.length - 1].latitude;
                                            let longitude = roadmaps[roadmaps.length - 1].longitude;

                                            if (latitude && longitude) {
                                                bounds.push([latitude, longitude]);
                                            }
                                        }

                                        viewTech = viewTech.set(location.id, location);
                                    });

                                    this.setState({
                                        openKeys: nextOpenKeys,
                                        bounds,
                                        viewIssues,
                                        viewMarker,
                                        viewTech
                                    });
                                } else {
                                    this.setState({openKeys: nextOpenKeys});
                                }
                            }}
                            openKeys={this.state.openKeys}
                        >
                            {users.map((userMap) => {
                                const user = userMap.toObject();

                                let overviewByIssue = this.state.overviewByIssues.get(user.id.toString());
                                let statusColor = '#9E9E9E';
                                let roadmap;

                                let device = this.props.techLocation.get(user.deviceID ? user.deviceID.toString() : 0);
                                if (device && device.roadmaps && device.roadmaps.length > 0) {
                                    roadmap = device.roadmaps[device.roadmaps.length - 1];

                                    statusColor = this.getStatuscolor(roadmap);
                                }

                                if (user.groupId && user.groupId === 57) {
                                    return <Menu.SubMenu
                                        style={{
                                            display: 'inline-flex',
                                            width: '100%',
                                            textAlign: 'left',
                                        }}
                                        key={`user#${user.id.toString()}#${user.deviceID}`}
                                        title={
                                            <div>
                                                <Tag
                                                    color={statusColor}
                                                    style={{
                                                        position: 'relative',
                                                        top: '6px',
                                                        height: '30px',
                                                        paddingTop: '4px',
                                                        paddingRight: '13px',
                                                        fontWeight: '600',
                                                        fontSize: '13px',
                                                        width: '110px',
                                                        boxShadow: 'rgba(0, 0, 0, 0.71) 0px 0px 3px',
                                                        float: 'left'
                                                    }}
                                                >
                                                    <div>
                                                        <p
                                                            style={{
                                                                width: '100%',
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            {parseUsername(user.firstname, user.lastname)}
                                                        </p>
                                                    </div>
                                                </Tag>
                                                {
                                                    roadmap ?
                                                        <span>
                                                            <p style={{
                                                                textAlign: 'left',
                                                                fontStyle: 'italic',
                                                                display: 'block'
                                                            }}>
                                                                {this.getStatusName(roadmap.status)}
                                                                - {roadmap.duration}
                                                            </p>
                                                            <p style={{
                                                                textAlign: 'left',
                                                                fontStyle: 'italic',
                                                                display: 'block',
                                                                position: 'relative',
                                                                top: '-16px',
                                                                width: '100%',
                                                                height: '35px',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden'
                                                            }}>
                                                                {roadmap.addr ? roadmap.addr : `${roadmap.latitude}, ${roadmap.longitude}`}
                                                            </p>
                                                        </span>
                                                        : null
                                                }
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '0px',
                                                    right: '30px'
                                                }}>
                                                    {
                                                        overviewByIssue && overviewByIssue.maintenance > 0 ?
                                                            <span style={{
                                                                marginRight: '5px',
                                                                border: '1px solid #0054ffcc',
                                                                padding: '0px 10px',
                                                                borderRadius: '4px'
                                                            }}>
                                                                <i style={{
                                                                    fontSize: '12px',
                                                                    position: 'relative',
                                                                    top: '1px',
                                                                    right: '4px',
                                                                    color: '#0054ffcc'
                                                                }}
                                                                   className={'material-icons'}>
                                                                {this.getIconByStatus(7)}
                                                                </i>
                                                                {overviewByIssue.maintenance}
                                                            </span> : null
                                                    }

                                                    {
                                                        overviewByIssue && overviewByIssue.done > 0 ?
                                                            <span style={{
                                                                border: '1px solid green',
                                                                padding: '0px 10px',
                                                                borderRadius: '4px',
                                                                marginRight: '5px',
                                                            }}>
                                                                <i style={{
                                                                    fontSize: '13px',
                                                                    position: 'relative',
                                                                    top: '2px',
                                                                    right: '4px',
                                                                    fontWeight: 'bold',
                                                                    color: 'green'
                                                                }}
                                                                   className={'material-icons'}>
                                                                    {this.getIconByStatus(3)}
                                                                </i>
                                                                {overviewByIssue.done}
                                                            </span> : null
                                                    }

                                                    {
                                                        overviewByIssue && overviewByIssue.cancel > 0 ?
                                                            <span style={{
                                                                marginRight: '5px',
                                                                border: '1px solid red',
                                                                padding: '0px 10px',
                                                                borderRadius: '4px'
                                                            }}>
                                                                <i style={{
                                                                    fontSize: '13px',
                                                                    position: 'relative',
                                                                    top: '2px',
                                                                    right: '4px',
                                                                    fontWeight: 'bold',
                                                                    color: 'red'
                                                                }}
                                                                   className={'material-icons'}>
                                                                    {this.getIconByStatus(5)}
                                                                </i>
                                                                {overviewByIssue.cancel}
                                                            </span> : null
                                                    }
                                                </div>
                                            </div>
                                        }
                                    >
                                        {
                                            this.props.issues && this.props.issues.length > 0 ?
                                                this.props.issues.map((issue) => {
                                                        if (!issue.assignedToID) {
                                                            return null;
                                                        }

                                                        let assignedMap = Map({});

                                                        assignedMap = assignedMap.set(issue.assignedToID.toString(), true);

                                                        if (issue.assignedMore && issue.assignedMore.length > 0) {
                                                            let arrAssignedMore = issue.assignedMore.split(',');

                                                            if (arrAssignedMore && arrAssignedMore.length > 0) {
                                                                arrAssignedMore.map((assignedID) => {
                                                                    assignedMap = assignedMap.set(assignedID, true);
                                                                });
                                                            }
                                                        }

                                                        if (assignedMap.get(user.id.toString())) {
                                                            return <Menu.Item
                                                                style={{
                                                                    display: 'block',
                                                                    width: '100%',
                                                                    textAlign: 'left',
                                                                    height: 'auto'
                                                                }}
                                                                key={`issue#${issue.id.toString()}#child`}>
                                                                {
                                                                    issue.latitude && issue.longitude ?
                                                                        <Icon
                                                                            style={{
                                                                                right: '7px',
                                                                                position: 'absolute',
                                                                                top: '13px',
                                                                                fontSize: '14px',

                                                                            }}
                                                                            type="environment"/> : null
                                                                }
                                                                <p
                                                                    style={{
                                                                        lineHeight: '2.2em',
                                                                        fontSize: '14px',
                                                                    }}
                                                                >
                                                                    <strong>
                                                                        <i style={{
                                                                            fontSize: '13px',
                                                                            position: 'relative',
                                                                            top: '2px',
                                                                            right: '4px'
                                                                        }}
                                                                           className={'material-icons'}>
                                                                            {this.getIconByStatus(issue.statusID)}
                                                                        </i>
                                                                        {this.parsePanelHeader(issue)}
                                                                    </strong>
                                                                </p>
                                                                <p
                                                                    style={{
                                                                        lineHeight: '1.2em',
                                                                        fontSize: '11px',
                                                                        position: 'relative',
                                                                        top: '-3px',
                                                                        whiteSpace: 'pre-line'
                                                                    }}
                                                                >{issue.clientAddress}</p>
                                                            </Menu.Item>
                                                        }

                                                        return null;
                                                    }
                                                )
                                                : null
                                        }
                                    </Menu.SubMenu>
                                } else {
                                    return null;
                                }
                            })}

                            {this.props.issues && this.props.issues.length > 0 ?
                                this.props.issues.map((issue) => {
                                        if (!issue.assignedToID || issue.assignedToID === 0) {
                                            if (issue.statusID === 1 || issue.statusID === 8 || issue.statusID === 7) {
                                                return <Menu.Item
                                                    style={{
                                                        display: 'block',
                                                        width: '100%',
                                                        textAlign: 'left',
                                                        height: 'auto',
                                                        paddingTop: '3px',
                                                        paddingBottom: '3px'
                                                    }}
                                                    key={`issue#${issue.id.toString()}`}>
                                                    {
                                                        issue.latitude && issue.longitude ?
                                                            <Icon
                                                                style={{
                                                                    right: '7px',
                                                                    position: 'absolute',
                                                                    top: '13px',
                                                                    fontSize: '14px',

                                                                }}
                                                                type="environment"/> : null
                                                    }
                                                    <p
                                                        style={{
                                                            lineHeight: '2.2em',
                                                            fontSize: '14px',
                                                        }}
                                                    >
                                                        <strong>
                                                            <i style={{
                                                                fontSize: '13px',
                                                                position: 'relative',
                                                                top: '2px',
                                                                right: '4px'
                                                            }}
                                                               className={'material-icons'}>
                                                                {this.getIconByStatus(issue.statusID)}
                                                            </i>
                                                            {this.parsePanelHeader(issue)}
                                                        </strong>
                                                    </p>
                                                    <p
                                                        style={{
                                                            lineHeight: '1.2em',
                                                            fontSize: '11px',
                                                            position: 'relative',
                                                            top: '-3px',
                                                            whiteSpace: 'pre-line'
                                                        }}
                                                    >{issue.clientAddress}</p>
                                                </Menu.Item>
                                            }
                                        }

                                        return null;
                                    }
                                )
                                : null
                            }
                        </Menu>
                    </div>
                </Sider>

                <Content style={{background: '#fff', padding: 0, margin: 0, minHeight: 280}}>
                    <MapLeftlet
                        bounds={this.state.bounds}
                        zoom={13}
                        style={{height: '100%'}}>

                        <TileLayer url="https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}&s=Ga"/>

                        {this.props.issues && this.props.issues.length > 0 ?
                            this.props.issues.map((issue) => {
                                if (issue && issue.latitude && issue.longitude && this.state.viewMarker.get(issue.id.toString())) {
                                    return <Marker
                                        key={`marker${issue.id}`}
                                        icon={divIcon({
                                            className: `leaftlet-div-icon`,
                                            iconAnchor: [0, 24],
                                            labelAnchor: [-6, 0],
                                            popupAnchor: [0, -36],
                                            html: `<span
                                                        style="background-color: ${this.getColorByAssignedID(issue.assignedToID)};z-index: 100">
                                                        <i class="material-icons">${this.getIconByStatus(issue.statusID)}</i>
                                                        <div class="marker-icon-border"></div>
                                                    </span>
                                                    <div class="marker-tranform"></div>
                                                    `
                                        })}
                                        ref="marker"
                                        position={[issue.latitude, issue.longitude]}>
                                        <Tooltip
                                            className='maps-tooltip'
                                            direction='center'
                                            offset={[-5, -10]}
                                            opacity={1} permanent>
                                            <span style={{
                                                color: this.state.issue
                                                && this.state.issue.id === issue.id ?
                                                    '#de004e' : '#111'
                                            }}>{this.getTooltipInfo(issue)}</span>
                                        </Tooltip>
                                        <Popup>
                        <span>
                        <span
                            style={{
                                width: '100%',
                                textAlign: 'center',
                                background: this.getColorByAssignedID(issue.assignedToID),
                                color: '#fff',
                                float: 'left',
                                borderTopLeftRadius: '5px',
                                borderTopRightRadius: '5px',
                                padding: '5px',
                                fontWeight: 600,
                                marginBottom: '10px'
                            }}
                        >
                            {this.getHeaderName(issue.assignedToID)}
                            </span>
                            <span style={{display: 'block', marginLeft: '10px', paddingRight: '10px'}}>
                            <strong style={{display: 'inline-flex'}}>
                            Thời gian :</strong>
                            <span style={{marginLeft: '5px'}}>{issue.startTime}</span>
                            </span>
                            <span style={{display: 'block', marginLeft: '10px', paddingRight: '10px'}}>
                            <strong style={{display: 'inline-flex'}}>
                            Đia Chỉ :</strong>
                            <span style={{marginLeft: '5px'}}>{issue.clientAddress}</span>
                            </span>
                            <span style={{display: 'block', marginLeft: '10px', paddingRight: '10px'}}>
                            <strong style={{display: 'inline-flex'}}>
                            Nhân viên KD :</strong>
                            <span
                                style={{marginLeft: '5px'}}>{this.getHeaderName(issue.saleID)}</span>
                            </span>
                            {
                                this.state.viewMarker.get(issue.id.toString()).kmDistance
                                && this.state.isShowIssueDetail
                                && this.state.issue.id !== issue.id
                                && this.state.openKeys.length === 0 ?
                                    <span style={{display: 'block', marginLeft: '10px', paddingRight: '10px'}}>
                                        <strong style={{display: 'inline-flex'}}>
                                            Khoảng cách :</strong>
                                        <span
                                            style={{marginLeft: '5px'}}>
                                            {this.getDistance(issue.id.toString())}
                                        </span>
                                    </span> : null
                            }

                            {
                                this.state.viewMarker.get(issue.id.toString()).duration
                                && this.state.isShowIssueDetail
                                && this.state.issue.id !== issue.id
                                && this.state.openKeys.length === 0 ?
                                    <span style={{display: 'block', marginLeft: '10px', paddingRight: '10px'}}>
                                        <strong style={{display: 'inline-flex'}}>
                                            Thời gian :</strong>
                                        <span
                                            style={{marginLeft: '5px'}}>
                                            {this.getDuration(issue.id.toString())}
                                        </span>
                                    </span> : null
                            }
                        </span>

                                        </Popup>
                                    </Marker>
                                }

                                return null;
                            })
                            : null
                        }

                        {
                            this.props.techLocation.map((location) => {
                                let roadmaps = location.roadmaps;

                                if (roadmaps && roadmaps.length > 0) {
                                    let roadmap = roadmaps[roadmaps.length - 1];
                                    let isView = this.state.viewTech.get(location.id);

                                    if (roadmap.latitude && roadmap.longitude && isView) {
                                        return <Marker
                                            key={location.id}
                                            ref="marker"
                                            icon={this.getStatusIcon(roadmap.status)}
                                            position={[roadmap.latitude, roadmap.longitude]}>
                                            <Tooltip
                                                className='tech-tooltip'
                                                direction='center'
                                                offset={[-30, 49]}
                                                opacity={1}
                                                permanent>
                                                <p style={{
                                                    width: '50px',
                                                    height: '30px',
                                                    color: '#fff',
                                                    whiteSpace: 'pre-line',
                                                    fontSize: '11px',
                                                    textAlign: 'center',
                                                    padding: '2px 5px',
                                                    fontWeight: 600,
                                                    lineHeight: '1.2em',
                                                    textTransform: 'uppercase'
                                                }}>
                                                    {this.getTechName(location.id)}
                                                </p>
                                            </Tooltip>
                                        </Marker>
                                    }
                                }

                                return null
                            })
                        }

                    </MapLeftlet>
                </Content>
            </Layout>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/schedule/issues.maps.js